export default function assertKeys(object = {}, arrKeys = []) {
  arrKeys.forEach((key) => {
    if (typeof object[key] === 'undefined') throw new Error(`Required key ${key} was undefined!`);
  });
}
